import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';
import ParticleBackground from '../components/ParticleBackground';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Login = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({ name: '', email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const endpoint = isLogin ? '/api/auth/login' : '/api/auth/register';
      const res = await axios.post(`${BACKEND_URL}${endpoint}`, formData);
      
      localStorage.setItem('token', res.data.access_token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      
      toast.success(isLogin ? "Ravi de vous revoir !" : "Bienvenue chez Jeanjo Unis !");
      navigate('/dashboard');
    } catch (e) {
      toast.error(e.response?.data?.detail || "Une erreur est survenue");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 relative">
       <ParticleBackground />
       <div className="absolute inset-0 bg-black/60 z-0" />
       
       <div className="bg-neutral-900/80 backdrop-blur-xl border border-white/10 p-8 rounded-2xl w-full max-w-md relative z-10 shadow-2xl">
          <div className="text-center mb-8">
             <h1 className="text-3xl font-bold mb-2">Espace Artiste</h1>
             <p className="text-gray-400">{isLogin ? 'Accédez à vos sessions et fichiers' : 'Créez votre compte artiste'}</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
             {!isLogin && (
                <div>
                   <label className="block text-sm font-bold mb-2 text-gray-300">Nom d'artiste</label>
                   <input 
                      type="text" 
                      required
                      className="w-full bg-black/50 border border-white/10 rounded-lg p-3 focus:outline-none focus:border-purple-500 transition-colors"
                      value={formData.name}
                      onChange={e => setFormData({...formData, name: e.target.value})}
                   />
                </div>
             )}
             
             <div>
                <label className="block text-sm font-bold mb-2 text-gray-300">Email</label>
                <input 
                   type="email" 
                   required
                   className="w-full bg-black/50 border border-white/10 rounded-lg p-3 focus:outline-none focus:border-purple-500 transition-colors"
                   value={formData.email}
                   onChange={e => setFormData({...formData, email: e.target.value})}
                />
             </div>
             
             <div>
                <label className="block text-sm font-bold mb-2 text-gray-300">Mot de passe</label>
                <input 
                   type="password" 
                   required
                   className="w-full bg-black/50 border border-white/10 rounded-lg p-3 focus:outline-none focus:border-purple-500 transition-colors"
                   value={formData.password}
                   onChange={e => setFormData({...formData, password: e.target.value})}
                />
             </div>

             <button 
                type="submit" 
                disabled={loading}
                className="w-full py-3 bg-purple-600 hover:bg-purple-700 text-white font-bold rounded-lg transition-colors mt-6"
             >
                {loading ? 'Chargement...' : (isLogin ? 'Se connecter' : "S'inscrire")}
             </button>
          </form>

          <div className="mt-6 text-center text-sm text-gray-400">
             {isLogin ? "Pas encore de compte ? " : "Déjà un compte ? "}
             <button 
                onClick={() => setIsLogin(!isLogin)}
                className="text-purple-400 hover:text-purple-300 font-bold underline"
             >
                {isLogin ? "Créer un compte" : "Se connecter"}
             </button>
          </div>
       </div>
    </div>
  );
};

export default Login;
